import React from 'react'

const Body = ({ children }) => {
  return (
    <div className="flex w-full flex-col items-center gap-6">{children}</div>
  )
}

export default Body
